export default class Time {
    constructor(hours, minutes) {
        this.hours = hours;
        this.minutes = minutes;
    }

    durationTo(time) {
        const minutesFrom = this.hours * 60 + this.minutes;
        let minutesTo = time.hours * 60 + time.minutes;

        if (minutesTo < minutesFrom) {
            minutesTo += 24 * 60;
        }

        let minutes = minutesTo - minutesFrom;

        const hours = Math.floor(minutes / 60);
        minutes = minutes % 60;

        if (minutes < 10) {
            minutes = `0${minutes}`;
        }

        return `${hours}:${minutes}`;
    }

    durationInMinutes(other) {
        return (other.hours - this.hours) * 60 + other.minutes - this.minutes;
    }

    toString() {
        let hours = this.hours;
        let minutes = this.minutes;
        if (hours < 10) {
            hours = `0${hours}`;
        }
        if (minutes < 10) {
            minutes = `0${minutes}`;
        }

        return `${hours}:${minutes}`;
    }

    isAfter(time) {
        return this.hours * 60 + this.minutes > time.hours * 60 + time.minutes;
    }

    static fromString(string) {
        if (!/^([01]\d|2[0-3]):[0-5]\d$/.test(string)) {
            throw new Error(`${string} is not a valid time format`);
        }

        const elements = string.split(':');
        const hours = Number.parseInt(elements[0]);
        const minutes = Number.parseInt(elements[1]);

        return new Time(hours, minutes);
    }
}
